const KpiCard = ({ label, value }) => (
  <div className="bg-white border rounded-lg p-4 shadow-sm">
    <p className="text-sm text-slate-500">{label}</p>
    <p className="text-lg font-semibold">{value}</p>
  </div>
);

export default KpiCard;
